import { useState } from 'react';
import { GoogleMaps } from '../../components/maps.component';
import './roof-area.component.css';

export const RoofAreaSlide = ({
    latitude,
    longitude,
    roofArea,
    onRoofAreaChange,
    onContinue
}: {
    latitude: number;
    longitude: number;
    roofArea: number;
    onRoofAreaChange: (value: number) => void;
    onContinue: (polygon: google.maps.Polygon) => void;
}) => {
    // State
    const [polygon, setPolygon] = useState<google.maps.Polygon | null>(null);
    const [defaultPolygon, setDefaultPolygon] = useState(true);
    const [resetPolygon, setResetPolygon] = useState(false);

    return (<div className="row roof-area">
        <div className="col-6">
            <h2>
                Dibuja <span className="inverted">la superficie de tu tejado</span> sobre esta imagen.
            </h2>
            <hr className="separator green-gradient"></hr>
            <p className="p-large">
                De esta manera, podremos <strong>calcular 
                las dimensiones</strong> de tu instalación.
            </p>
            <button disabled={defaultPolygon} className="fake-input button" onClick={() => setResetPolygon(!resetPolygon)}>
                <svg xmlns="http://www.w3.org/2000/svg" height="32px" width="32px" viewBox="0 0 179.019 179.019">
                    <g>
                        <g>
                            <path style={{ fill: "#545454" }} d="M138.121,138.357c-13.02,13.008-30.312,20.174-48.714,20.174c-37.955,0-68.84-30.867-68.876-68.81    l14.046,14.064c0.931,0.925,2.429,0.925,3.359,0c0.919-0.931,0.919-2.434,0-3.359L19.315,81.797L0.698,100.426    c-0.931,0.925-0.931,2.429,0,3.359c0.459,0.465,1.068,0.692,1.671,0.692c0.615,0,1.223-0.233,1.677-0.692l11.826-11.832    c1.235,39.531,33.689,71.328,73.512,71.328c19.673,0,38.164-7.661,52.079-21.57c0.925-0.925,0.925-2.429,0-3.353    C140.562,137.426,139.052,137.426,138.121,138.357z"/>
                            <path style={{ fill: "#545454" }} d="M178.32,75.234c-0.919-0.925-2.423-0.925-3.353,0L163.152,87.06    c-1.247-39.531-33.701-71.322-73.518-71.322c-19.685,0-38.17,7.661-52.085,21.57c-0.931,0.925-0.931,2.429,0,3.353    c0.919,0.931,2.429,0.931,3.353,0c13.014-13.008,30.312-20.174,48.714-20.174c37.949,0,68.84,30.861,68.888,68.81l-14.058-14.064    c-0.925-0.925-2.429-0.925-3.359,0c-0.919,0.931-0.919,2.434,0,3.359l18.623,18.623l18.617-18.623    C179.251,77.668,179.251,76.164,178.32,75.234z"/>
                        </g>
                    </g>
                </svg>
                Redibujar
            </button>
            <button disabled={!roofArea || !polygon} className="button" onClick={() => { onContinue(polygon!); }}>
                Continuar
            </button>
        </div>
        <div className="col-6">
            <GoogleMaps id="area-map"
                latitude={latitude}
                longitude={longitude}
                onPolygonChange={(area, polygon) => {
                    onRoofAreaChange(area);
                    setPolygon(polygon);

                    // Validate default
                    const defase = 0.0001;
                    const points = polygon.getPath().getArray().map(({ lat, lng }) => ({
                        lat: lat(),
                        lng: lng()
                    }));

                    if (points.length === 3) {
                        const firstPointMatch = points[0].lat === latitude + defase && points[0].lng === longitude - defase;
                        const secondPointMatch = points[1].lat === latitude + defase && points[1].lng === longitude + defase;
                        const thirdPointMatch = points[2].lat === latitude - defase && points[2].lng === longitude + defase;

                        setDefaultPolygon(firstPointMatch && secondPointMatch && thirdPointMatch);
                    } else {
                        // Default polygon is a triangle
                        setDefaultPolygon(false);
                    }
                }}
                withPolygon
                resetPolygon={resetPolygon}
            />
            <div className="roof-area--surface">
                <p>Superficie: {roofArea.toFixed(1)} M2</p>
            </div>
        </div>
    </div>);
}